import { render } from "./SmartPlanner.vue?vue&type=template&id=35ccb9ac&ts=true"
import script from "./SmartPlanner.vue?vue&type=script&lang=ts"
export * from "./SmartPlanner.vue?vue&type=script&lang=ts"

import "./SmartPlanner.vue?vue&type=style&index=0&id=35ccb9ac&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__